import React, { createContext, ReactNode, useContext, useEffect, useState } from 'react'
import { IUserData } from '../interfaces/ILogin'
import { useHistory } from 'react-router-dom';
import { AnalystService } from '../services/methods/AnalystService';
import { toast } from 'react-toastify';

interface UserProviderProps {
  children: ReactNode
}

interface IUserContextData {
  userInfo: IUserData;
  setUserInfo: (data: IUserData) => void;
  setAnalystColor: (analystColor: string) => void;
  storeUserInfo: (data: IUserData) => Promise<void>;
}

const UserContext = createContext({} as IUserContextData)

function UserProvider({ children }: UserProviderProps) {
  const analystService: AnalystService = new AnalystService();


  const [userInfo, setUserInfo] = useState<IUserData>({} as IUserData)


  const history = useHistory()

  async function storeUserInfo(data: IUserData) {
    await localStorage.setItem('ethosxAnalista:userInfo', JSON.stringify(data))
    setUserInfo(data)
  }

  async function getUserInfoFromStore() {
    if (!!userInfo) {
      const data = await localStorage.getItem('ethosxAnalista:userInfo')
      if (data) {
        setUserInfo(JSON.parse(data))
      } else {
        await localStorage.removeItem('ethosxAnalista:userInfo')
        await localStorage.removeItem('ethosxAnalista:token')
        await sessionStorage.removeItem('token')
        history.push('/login')

      }
    }
  }

  async function setAnalystColor(analystColor: string) {
    try {
      const token = await sessionStorage.getItem('token')
      const body = {
        color: analystColor
      }

      const { data } = await analystService.updateAnalyst(token!, userInfo.codigo, body)
      if (data.status === 'ok') {
        const responseUserStore = await localStorage.getItem('ethosxAnalista:userInfo')
        const userStore = JSON.parse(responseUserStore!)
        userStore.color = analystColor
        await localStorage.setItem('ethosxAnalista:userInfo', JSON.stringify(userStore))
        setUserInfo({
          ...userInfo,
          color: analystColor
        })
        toast.success(data.msg)
      } else {
        toast.error(data.msg)
      }


    } catch (error) {

    }
  }

  useEffect(() => {
    getUserInfoFromStore()
  }, [])

  return (
    <UserContext.Provider value={{
      userInfo,
      setUserInfo,
      setAnalystColor,
      storeUserInfo,
    }}>
      {children}
    </UserContext.Provider>
  )
}

function useUser() {
  const context = useContext(UserContext)

  return context
}

export { UserProvider, useUser }